import { render, staticRenderFns } from "./calendarItem.vue?vue&type=template&id=92dd9dec&scoped=true&"
import script from "./calendarItem.vue?vue&type=script&lang=js&"
export * from "./calendarItem.vue?vue&type=script&lang=js&"
import style0 from "./calendarItem.vue?vue&type=style&index=0&id=92dd9dec&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92dd9dec",
  null
  
)

export default component.exports